import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import BottomInfo from '@/view/layout/bottomInfo/bottomInfo';
import { activeAccount } from "@/api/user";
import { encrypt } from '@/utils/crypto';
import { store } from '@/store/index';
// import { mapGetters, mapMutations } from "vuex";
import { emailConfirm } from '@/api/team_member';
export default {
  name: "EmailConfirm",
  data: function data() {
    var _this = this;
    return {
      subTitle: "",
      validateFailed: false,
      showDialog: false,
      pwdModify: {
        username: '',
        password: '',
        confirmPassword: '',
        lastTeamId: 0
      },
      rules: {
        password: [{
          required: true,
          message: this.$t('person-setting.check-error-empty-newpwd'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('person-setting.check-error-length-pwd'),
          trigger: "blur"
        }],
        confirmPassword: [{
          required: true,
          message: this.$t('person-setting.check-error-empty-cfpwd'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('person-setting.check-error-length-pwd'),
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (value !== _this.pwdModify.password) {
              callback(new Error(_this.$t('person-setting.check-error-invalid-pwd')));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    };
  },
  components: {
    BottomInfo: BottomInfo
  },
  computed: {
    // ...mapGetters("user", ["userInfo", "token"]),
    // ...mapMutations("user", ["ResetUserInfo"]),
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.$refs.modifyPwdForm.validate(function (valid) {
                if (valid) {
                  activeAccount({
                    username: _this2.pwdModify.username,
                    password: encrypt(_this2.pwdModify.password),
                    lastTeamId: _this2.pwdModify.lastTeamId
                  }).then(function (res) {
                    if (res.code == 0) {
                      _this2.$message.success(_this2.$t('user.msg-success'));
                      store.commit('user/LoginOut');
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return emailConfirm({
              code: _this3.$route.query.code
            });
          case 2:
            res = _context2.sent;
            console.log(res);
            // 校验邮件是否过期
            if (res.code == 40030 || res.code == 40031) {
              _this3.validateFailed = true;
              _this3.subTitle = _this3.$t('user.email-vildate-result-subtitle');
            } else if (res.code == 0) {
              if (res.data.status == 0) {
                // 如果未激活，则进行用户信息填写
                _this3.showDialog = true;
                _this3.pwdModify.username = res.data.userName;
                _this3.pwdModify.lastTeamId = res.data.teamId;
              } else if (res.data.status == 1) {
                store.commit('user/LoginOut');
                // 如果已经激活，直接跳到对应的team(token也要更新，否则token里的teamID不对)
                // if(this.token && res.data.ID == this.userInfo.ID){
                //   this.userInfo.lastTeamId = res.data.lastTeamId
                //   this.userInfo.authorityId = res.data.authorityId
                //   this.userInfo.authority = res.data.authority
                //   Promise.all([
                //     store.dispatch('router/SetAsyncRouter', {}, { root: true }),
                //     store.dispatch('api/getUserApis', {authorityId: this.userInfo.authorityId}, { root: true }),
                //     store.dispatch('viewinfo/updateTplMap')]).then(()=>{ 
                //   }).catch((error) => {
                //     console.log(error)
                //   })
                //   resetRouter()
                //   const asyncRouters = store.getters['router/asyncRouters']
                //   this.$router.addRoutes(asyncRouters)

                //   this.$router.push({ name: this.userInfo.authority.defaultRouter})
                // }else{
                //   store.commit('user/LoginOut')
                // }
              }
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};